<template>
  	<div>
		<div class="intro" v-bind:class="$i18n.locale != 'en-US' ? 'red' : 'blue'">
  			<div class="page-wrapper v-center-flex v-center-flex--intro">
				<figure class="intro__image"><img :src="require('@/assets/pages/blog/sync_diagram.jpg')" alt="" class="img-fluid" /></figure>
				<div class="intro__content">
					
					<div class="intro__content-wrap">
						<div class="intro__logo"><img :src="require('@/assets/pages/blog/mlstouch_logo.png')" alt=""/></div>
						<hr>
						<h1 class="intro__title"><span class="u-weight-bolder">The Most ADVANCED</span><br>Mobile MLS App<br><span class="u-weight-bolder">For Agents</span></h1>
					</div>
				</div>
			</div>
		</div>
		<div class="page-wrapper">
			<article>
				<header class="article-head">
					<div class="article-head__top">
						<ul class="article-details">
							<li class="article-details__item article-details__item--calendar">August 2019</li>
							<li class="article-details__item">By Lisa Gaetz</li>
							<li class="article-details__item">Blog Post</li>
						</ul>
						<!--<ul class="social-links">
							<li class="social-links__item">1</li>
							<li class="social-links__item">2</li>
							<li class="social-links__item">3</li>
							<li class="social-links__item">4</li>
						</ul>-->
					</div>
					<h1 class="title title--main">5 MLS-Touch - Matrix Integrations That Agents and Their Clients Love</h1>
					
				
				</header>
				<div class="blog-point">
					<p>Agents spend most of their time away from their office. They need to stay connected to their MLS, responding to their leads, and engaged with their clients, no matter where they are.</p>
					<p>MLS-Touch, the industry’s most advanced mobile MLS app, gives agents the tools they need to do all of this and more. It has all the essential features agents depend on including fully customizable listing searches, live market stats, hot sheets, instant comparables and property history.</p>
					<p>It also has some advanced features that really set it apart!  Like branded apps and automatic listing posts to Facebook.</p>
					<p>The real power, though, is in the client engagement which thanks to integrations made possible with our <span class="u-weight-semibold">Alliance Partner, CoreLogic®</span>, creates a seamless ecosystem for delightfully easy collaboration during the home buying process. </p>
					<p class="u-weight-semibold">Here’s 5 MLS-Touch - Matrix™ integrations that Agents and their clients love. </p>
				</div>   
				<div class="blog-point">
					<h3 class="title title--sub">#1: Powerful Contact Management in the Palm of Your Hand</h3>
					<h4 class="title title--sub-sm ">View, add and edit MLS contacts in either Matrix or MLS-Touch</h4>
					<p>Agents need access to their contact info from every device they use. Deep integration links between MLS-Touch and Matrix enable agents to access their Matrix contacts through their mobile app. Agents can add/edit contacts through either platform and the changes will automatically sync with the other, creating time-saving efficiencies and eliminating duplicate data entry. </p>
					<p>Agents can take advantage of this feature to quickly access contact info and connect with their clients, invite them to use their branded app (where their clients have access to 100% of the market listings), and send Listing Details <span class="citation"> from wherever they are</span>. It’s never been easier! </p>
					<p>Contact Sync is available now to more than 180,000 real estate professionals in over 30 MLS markets. </p>
				</div>
				<div class="blog-image">
					<img src="@/assets/pages/blog/contact_sync.jpg" class="img-responsive-md"/>
				</div>
				<div class="blog-point">
					<h3 class="title title--sub">#2: All Client Activities Are Tracked and Managed in the Mobile App </h3>
					<h4 class="title title--sub-sm ">Client Favorites and Suggested Listings flow seamlessly between Matrix Client Portal and Agent-Branded App </h4>
					<p>Clients love to search for their own listings and keep track of the ones they like. And they want an easy collaboration process to share that information with their agent. It shouldn’t be painful! It should be seamless and easy.</p>
					<p>With MLS-Touch, when a client Favorites a listing in either their Client Portal or their agent-branded app it is automatically available to them in <span class="citation">both</span> platforms.</p>
					<p>When their agent suggests a listing, it’s instantly available to view in the Portal <span class="citation">and</span> their mobile app.</p> 
					<p>This is what a seamless experience for homebuyers looks like! Thanks to our deep integrations with the Client Portal, clients can track and view their preferred listings and suggested listings whether they’re on their laptop or mobile phone.</p>
					<p>Agents are notified of listings flagged as Favorites and Possibilities so they can quickly follow up with their client. In addition, flagged listings and suggested listings are tracked and synced in the contact records all in real-time, keeping client communications and activities organized and easily referenced in <span class="citation">one place</span> from the convenience of their phone.</p>
					<p>Portal Sync is available now to more than 180,000 real estate professionals in over 30 MLS markets.</p>
				</div>
				<div class="blog-image">
					<img src="@/assets/pages/blog/fav_sync.jpg" class="img-responsive-md"/>
				</div>
				<div class="blog-point">
					<h3 class="title title--sub">#3:  Listing Edit</h3>
					<h4 class="title title--sub-sm ">Quick edits to Price, Public Remarks and Private Remarks on the go</h4>
					<p>Agents are always on the move, and their phone is their lifeline to the MLS. When a seller wants to reduce the price on their listing, their agent should be able to make that time-sensitive change right there on the spot, not hours later when they’re back at their desk. </p>
					<p>With MLS-Touch agents can update Price, Public Remarks and Private Remarks in seconds and the changes instantly update in the MLS. </p>
					<p>Listing Edit is live now and available to over 110,000 agents! Additional rollouts are scheduled in the coming weeks. </p>
				</div>
				<div class="blog-image">
					<img src="@/assets/pages/blog/edit_listing.jpg" class="img-responsive-sm"/>
				</div>

				<div class="blog-point">
					<h3 class="title title--sub">#4: Carts Can Be Managed Through MLS-Touch</h3>
					<h4 class="title title--sub-sm ">Create and manage Carts in either Matrix or MLS-Touch</h4>
					<p>Carts allow Agents to combine listings from different searches and different property types into one list. The collection of listings can be viewed, emailed or printed at any time. Just like with Matrix, MLS-Touch users can create and manage Client Carts, and add listings to the Carts, from the convenience of their phone! The data syncs automatically across both platforms, eliminating the need to maintain duplicate carts.</p>
					<p>Cart Sync is available now to more than 180,000 real estate professionals in over 30 MLS markets.</p>
				</div>
				<div class="blog-image">
					<img src="@/assets/pages/blog/cart_sync.jpg" class="img-responsive-md"/>
				</div>
				<div class="blog-point">
					<h3 class="title title--sub">#5: Saved Searches Sync</h3>
					<h4 class="title title--sub-sm ">Mobile access to Matrix Saved Searches</h4>
					<p>Saved Searches make property search easier. They’re time savers so that criteria doesn’t have to be re-entered to view new listings for a buyer. They also make it easy for agents to monitor listings in a particular neighborhood or area.</p>
					<p>It’s information that should be at the Agent’s fingertips and with MLS-Touch it is! MLS-Touch keeps in perfect sync with Matrix, providing quick access to Saved Searches from within the App. No more duplicate entry of important Saved Searches! What’s not to love about that? </p>
					<p>Saved Searches is available now to more than 180,000 real estate professionals in over 30 MLS markets.</p>
				</div>
				<div class="blog-image">
					<img src="@/assets/pages/blog/saved_searches_sync.jpg" class="img-responsive-md"/>
				</div>
				<footer class="article-foot">
					<h3 class="title title--sub">Press Contact</h3>
					<p>Lisa Gaetz<br>Director of Marketing<br><a href="mailto:lisa@prospects.com">lisa@prospects.com</a><br>Phone: <a href="phone:8887659223">(888) 765-9223 ext.207</a></p>
				</footer>
			</article>
		</div>
  	</div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {	
	},

	data () {
		 return {
		 }
	},

	computed: {

	},

	methods: {
	}
};
</script>
<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400i&display=swap');

	$quote-font: 'Libre Baskerville', serif;
	$news-font : 'Montserrat', sans-serif;

	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg";
	  }
	}
//main article font
@mixin newsFont($colour: false, $size: false, $weight: false,  $lh: false) {
    font-family: $news-font, Helvetica, Arial, sans-serif;
    //@if $size { font-size: $size; }
    @if $colour { color: $colour; }
    @if $size { font-size: $size; }
    @if $weight { font-weight: $weight; }
    @if $lh { line-height: $lh; }
}


	.article-head {
		margin: 20px 0;
		padding: 0 0 20px;
		border-bottom: 1px solid #ccc;
		@include media-breakpoint-up(sm) {
			margin: 40px 0;
		}
		
	}
	.article-head__top {
		display: flex;
		justify-content: space-between;
	}
	.article-details {
		list-style-type: none;
		display: flex;
		margin-bottom: 2em;
		@include newsFont (#000, 12px, 400, 18px);
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 16px, 400, 20px);
		}
	}
	.article-details__item {
		margin-right: 1em;
		display: flex;
		&:after {
			content: '|';
			margin-left: 1em;
		}
		&:last-child {
			&:after {
				content: none;
			}
		}
		&--calendar {
			&:before {
				content: url(./../../assets/calendar.svg);
				width: 17px;
				height: 17px;
				margin-right: 10px;
			}
		}
	}
	.social-links {
		list-style-type: none;
		display: flex;
	}
	.social-links__item {
		margin-left: 10px;
	}

	.title {
		margin-bottom: 1em;
	}
		
	.title--main {
		@include newsFont (#000, 20px, 500, 30px);
		text-transform: uppercase;
		margin-bottom: 1em;
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 27px, 200, 40px);
		}
		@include media-breakpoint-up(lg) {
			@include newsFont (#000, 48px, 200, 52px);
			width: 80%;
		}
	}

	.title--sub {
		@include newsFont (#000, 18px, 700, 20px);
	}
	.title--sub-sm {
		@include newsFont (#e02428, 16px, 500, 18px);
	}

	p {
		margin-bottom: 1em;
		line-height: 2em;
		font-weight: 300;
	}
	.article-foot {
		background: #f7f7f7;
		padding: 30px 30px 5px;
		margin-bottom: 25px;
	}
	.blog-point {
		margin-bottom: 2em;
	}
	.blog-image {
		margin-bottom: 4em;
	}
	.blog-image img {
		width:100%;
		display: block;
		margin: 0 auto;
	}
	.img-responsive-sm {
		max-width: 300px;
	}
	.img-responsive-md {
		max-width: 600px;
	}
	.img-responsive-lg {
		max-width: 750px;
	}

	.v-center-flex {
		display: flex;
		align-items: center;
	}

	.intro {
		position: relative;
		min-height: auto;
		background: #404f60;
		flex-direction: column-reverse;
		overflow-x: hidden;
		display: flex;
		padding-bottom: 10px;
		@include media-breakpoint-up(sm) {
			padding-bottom: 30px;
		}
		@include media-breakpoint-up(lg) {
			padding-bottom: 50px;
		}
	}
	hr{
		display: none;
		@include media-breakpoint-up(lg) {
			display: block;
			height: 1px;
    		border: 0; 
			border-top: 1px solid #38c2f0;
			padding: 0;
			width: 80px;
			float: left !important;
		}
	}
	.intro__title {
			font-weight: 300;
			font-size: 2rem;
			text-align: center;
			margin: 10px 0 10px;
			color: #fff;
			line-height: 1.4em;
			@include media-breakpoint-up(sm) {
				text-align: left;
				font-size: 3rem;
				margin: 30px 0 20px;
			}
			@include media-breakpoint-up(lg) {
				font-size: 4.6rem;
				line-height: 1.3em;
				font-weight: 300;
				text-align: left;
				margin: 90px 0 20px;
			}
		}
	.intro__logo{
		margin: 15px 0 0;
		text-align: center;
		@include media-breakpoint-up(sm) {
			text-align: left;
			margin: 20px 0 40px 0;
			padding: 40px 0 0;
			text-align: left;
		}
	}
	.intro__logo img{
		max-width: 200px;
		@include media-breakpoint-up(sm) {
			max-width: 300px;
		}
	}
	.v-center-flex--intro {
		flex-direction: column;
		@include media-breakpoint-up(sm) {
		flex-direction: row;
		}
	}
	.intro__image {
		order: 0;
		flex: 1;
		padding: 0;
		margin: 25px 0 0 0;
		@include media-breakpoint-up(sm) {
			margin: 25px 0 0 0;
			max-width: 250px;
		}
		@include media-breakpoint-up(lg) {
			order: 0;
			margin: 50px 0 0 0;
			max-width: 620px;
		}
	}
	.intro__image img {
		max-width: 200px;
		@include media-breakpoint-up(sm) {
			max-width:250px;
		}
		@include media-breakpoint-up(lg) {
			max-width:360px;
		}
	}
	.intro__content {
		order: 1;
		flex: 1;
		padding: 0 20px;
		display: flex;
		justify-content: center;
		@include media-breakpoint-up(lg) {
			order: 1;
			padding: 0 40px 0 0;
			justify-content: flex-start;
		}
	}
	.intro__content-wrap {
	    max-width: 640px;
	    float: right;
	}
	</style>